import React from 'react';
import {Link} from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer-area">
            <div className="footer-top bg-1 "  style={{backgroundColor:"#d5bb9b"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="footer-widget footer-logo">
                                <h2>Interior Services</h2>
                                <p>Get FREE online interior live designing with cost ideas in kolkata west bengal happy to help 24/7 call or whatsapp our designer.</p>
                                <h4>Working Hours: </h4>
                                <span>Mon - Sat 10:00 - 6:30 Interior Working</span>
                               
                                <span>No Off (Only Urgent Services)</span>
                                <span>Best Price Interior Designer Kolkata</span>
                                <ul>
                                    <li><a href="https://www.facebook.com/people/Square-and-Angle/61553859827105/" target="_blank"><i className="fa fa-facebook"></i></a></li>
                                    <li><a href="https://www.linkedin.com/company/square-and-angle-interior/" target="_blank" rel="nofollow"><i className="fa fa-linkedin"></i></a></li>
                                    <li><a href="https://www.youtube.com/@SquareandAngle" target="_blank"><i className="fa fa-youtube"></i></a></li>
                                    <li><a href="https://www.instagram.com/square_and_angle/" target="_blank"><i className="fa fa-instagram"></i></a></li>
                                    <li style={{ display: 'block' }} />
                                </ul>
                            </div>
                        </div>

                        
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="footer-widget footer-contact">
                                <h4 className="widget-title">GET IN TOUCH</h4>
                                <ul>
                                    <li><i className="fa fa-home"></i>56 N, Bidhannagar Rd, Ultadanga, Kolkata, West Bengal 700067</li>
                                    <li><i className="fa fa-phone"></i>062890 01010 / 24H</li>
                                 
                                    <li><i className="fa fa-envelope"></i> info.interior@pranatigroup.in</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                            <div className="footer-widget footer-menu">
                                <h4 className="widget-title">Category</h4>
                                <ul>
                                    <li>
                                     <Link to="/">Home</Link></li>
              
            
            <li>
                <Link to="/about">About</Link>
               
            </li>
            <li>
                <Link to="/city_base">City </Link>
                
            </li>
            <li>
                <Link to="/sample_projects">Projects</Link>
                
            </li>
            <li>
                <Link to="/video_gallery">Gallery</Link>
                
            </li>
            <li>
               <Link to="/wardrobe_calculator">Budget</Link></li>

               
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="footer-widget newsletter">
                                <h4 className="widget-title">newsletter</h4>
                                <p>We want everyone in Kolkata to enjoy our interior, and you are requested to help.</p>
                                <p>Can you share your interior problems with us? If you have any questions you can call us.</p>
                                <button onClick="window.location.href = 'https://www.youtube.com/channel/UClVoaP_NLO2GocJgr0ezx9A?sub_confirmation=1';">subscribe</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </footer>
    );
};

export default Footer;